import React, { useState } from "react"
import Breadcrumb from "components/Common/Breadcrumb"
import { Card, CardBody } from "reactstrap"
import ColdCallForm from "./ColdCallForm"
import { FetchPostData } from "utils/Common_api_functions"
import Swal from "sweetalert2"
import { useNavigate } from "react-router-dom"
import Loader from "components/Loader/Loader"

const AddColdCall = () => {
  document.title = "Add Cold Call | Vintage Infra Equipment Sol PVT LTD"
  const [formData, setFormData] = useState({})
  const [loading, setLoading] = useState(false)

  const Navigate = useNavigate()

  const handleSubmit = async () => {
    const APIdata = await FetchPostData(setLoading, "cold/call", formData)
    if (APIdata?.data?.success) {
      Swal.fire({
        title: "Cold call added Successfully.",
        text: APIdata?.data?.message,
        icon: "success",
      })
      Navigate(-1)
    } else {
      Swal.fire({
        title: "Error Adding Cold Call",
        text: APIdata?.response?.data?.message,
        icon: "error",
      })
    }
  }

  return (
    <div className="page-content">
      {loading && <Loader />}
      <Breadcrumb
        title="Cold Calling Management"
        breadcrumbItem="Add Cold Call"
      />
      <Card>
        <CardBody>
          <ColdCallForm
            formData={formData}
            setFormData={setFormData}
            onSubmit={handleSubmit}
          />
        </CardBody>
      </Card>
    </div>
  )
}

export default AddColdCall
